export function EnumValue(value, name) {
    this.Value = value;
    this.Name = name;
}